import { render, staticRenderFns } from "./ChannelActivity.vue?vue&type=template&id=6c482a37&scoped=true&"
import script from "./ChannelActivity.vue?vue&type=script&lang=js&"
export * from "./ChannelActivity.vue?vue&type=script&lang=js&"
import style0 from "./ChannelActivity.vue?vue&type=style&index=0&id=6c482a37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c482a37",
  null
  
)

export default component.exports